import { render } from "./HomeView.vue?vue&type=template&id=1471f00d&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=1471f00d&scoped=true&lang=scss"

import exportComponent from "C:\\Data\\Dev\\Repos\\Wordminder\\src\\client\\wordminder\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1471f00d"]])

export default __exports__